




















import Vue from 'vue'
import moment from 'moment-timezone'
import { LIVE_DASHBOARD_TYPES, titleByLiveDashboardTypes, unitByLiveDashboardTypes } from '@/constants/live-dashboard'
import SeriesLine = echarts.EChartOption.SeriesLine
import XAxis = echarts.EChartOption.XAxis
import YAxis = echarts.EChartOption.YAxis

export default Vue.extend({
  props: {
    cardType: {
      type: String,
      required: true,
    },
    dataPoints: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      titleByLiveDashboardTypes,
      unitByLiveDashboardTypes,
      colorByLiveDashboardTypes: {
        [LIVE_DASHBOARD_TYPES.OxygenSaturations]: this.$vuetify.theme.themes.light.teal,
        [LIVE_DASHBOARD_TYPES.PulseRates]: this.$vuetify.theme.themes.light.primary,
      },
      chartOptions: null,
    }
  },
  computed: {
    unitLabel() {
      return unitByLiveDashboardTypes[this.cardType]
    },
    color() {
      return this.colorByLiveDashboardTypes[this.cardType]
    },
    shouldDisplayGradientColor() {
      return this.cardType === LIVE_DASHBOARD_TYPES.OxygenSaturations
    },
    minY() {
      return Math.min(...this.dataPoints.map(dp => dp.value))
    },
    maxY() {
      return Math.max(...this.dataPoints.map(dp => dp.value))
    },
    seriesData() {
      return this.dataPoints.map((dp, index) => {
        return {
          value: [index, dp.value],
        }
      })
    },
    visualMap() {
      return this.shouldDisplayGradientColor
        ? [
            {
              show: false,
              type: 'continuous',
              seriesIndex: 0,
              min: 90,
              max: 95,
              inRange: {
                color: [this.$vuetify.theme.themes.light.burgundy, this.color],
              },
            },
          ]
        : null
    },
  },
  mounted() {
    this.chartOptions = this.getFullOptions()
  },
  methods: {
    getFullOptions() {
      return {
        grid: [{ x: '10%', y: '24%', width: '80%', height: '70%' }],
        xAxis: {
          data: this.dataPoints.map(dp => {
            return dp.timestamp ? moment(dp.timestamp).format('HH:mm A') : '-'
          }),
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: true },
        } as XAxis,
        yAxis: {
          type: 'value',
          min: this.minY,
          max: this.maxY,
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false },
        } as YAxis,
        series: [
          {
            type: 'line',
            showAllSymbol: true,
            hoverAnimation: false,
            symbolSize: 12,
            lineStyle: {
              color: this.shouldDisplayGradientColor ? null : this.color,
            },
            itemStyle: {
              color: this.shouldDisplayGradientColor ? null : this.color,
            },
            emphasis: {
              symbolSize: 12,
            },
            label: {
              show: true,
              fontSize: 24,
              fontWeight: 'bold',
              color: this.shouldDisplayGradientColor ? null : this.color,
              backgroundColor: 'rgba(248,248,248, 1)',
              borderRadius: 4,
              padding: [4, 10],
            },
            data: this.seriesData as any,
          } as SeriesLine,
        ],
        tooltip: {},
        visualMap: this.visualMap,
      }
    },
  },
})
